import getComponent from './get-component';

const getFieldTemplates = () => {
  const component = getComponent();
  return component.getTemplates();
};

export default getFieldTemplates;
